import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import {
  createBillingAddressValidationShape,
  createCreditCardValidationShape,
  getDefaultCreditCardDetailsValues,
  getBillingAddressPayload,
  getDefaultBillingAddressValues,
} from "components/CreditCardForm/creditCardFormHelper";
import { BooksAddFundsFormValues } from "types/books";
import * as yup from "yup";
import {
  toastResponseError,
  toastResponseSuccess,
} from "../../../utils/responseMessageHelper";

const addFundsFormik = (
  t: TFunction,
  createRechargeBalance: any,
  redirect: () => Response,
  updateAmountFunds: (amount: string) => void,
  currentLocale = "en",
  defaultCountryCode = "US",
  currencySymbol: string,
  initialValues?: BooksAddFundsFormValues,
) => {
  const defaultValues: BooksAddFundsFormValues = {
    cardDetails: getDefaultCreditCardDetailsValues(),
    address: getDefaultBillingAddressValues(currentLocale, defaultCountryCode),
    amount: "",
  };
  const mergedInitialValues: BooksAddFundsFormValues = initialValues
    ? {
        ...defaultValues,
        ...initialValues,
        cardDetails: {
          ...defaultValues.cardDetails,
          ...initialValues.cardDetails,
        },
        address: {
          ...defaultValues.address,
          ...initialValues.address,
        },
      }
    : defaultValues;

  return {
    validateOnBlur: false,
    initialValues: mergedInitialValues,

    validationSchema: yup.object({
      amount: yup.string().required(t("error.requiredField")),
      cardDetails: yup.object(createCreditCardValidationShape(t)),
      address: yup.object(createBillingAddressValidationShape(t)),
    }),
    onSubmit: (
      values: BooksAddFundsFormValues,
      { setSubmitting, resetForm }: FormikHelpers<BooksAddFundsFormValues>,
    ) => {
      const { cardDetails, address, amount } = values;
      const { name, number, expiration, cvv } = cardDetails;
      const [month, year] = expiration.split("/");
      const cardNumber = number.split(" ").join("");
      const amountValue = amount !== null ? +amount : 0;

      const rechargeBalanceDto = {
        credit_card: {
          card_name: name,
          card_number: cardNumber,
          exp_month: month,
          exp_year: year,
          card_code: cvv,
          ...getBillingAddressPayload(address),
        },
        amount: amountValue,
      };

      setSubmitting(true);

      createRechargeBalance({ data: rechargeBalanceDto })
        .then(() => {
          resetForm();
          updateAmountFunds("");
          toastResponseSuccess(
            t("books.bankCard.successfulTransactions", {
              amount,
              currencySymbol,
            }),
          );
          setSubmitting(false);
          redirect();
        })
        .catch((error: Error) => {
          toastResponseError(error);
          setSubmitting(false);
        })
        .finally(() => setSubmitting(false));
    },
  };
};

export default addFundsFormik;
